import { Component, OnInit } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { AreaItemPack } from '../../models/area-item-pack';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { AreaItem } from '../../models/area-item';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-booking-event-packs',
  templateUrl: './booking-event-packs.component.html',
  styleUrls: ['./booking-event-packs.component.css']
})
export class BookingEventPacksComponent implements OnInit {

  constructor(
    private bookingStepService: BookingStepService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
    private bookingOrderService: BookingOrderService,
  ) { }

  ngOnInit(): void {
    this.loadingSpinnerService.show();
    this.bookingStepService.initialize().subscribe(
      done => {
        this.loadingSpinnerService.hide();
        this.logger.info('BookingPacksComponent: bookingStateService initialized.');
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`BookingPacksComponent: bookingStateService reinitialized error: ${error.message}.`);
      }
    );
  }

  get areaItemPacks(): AreaItemPack[] {
    return this.bookingOrderService.mainPageAreaItemPacks
      ? this.bookingOrderService.mainPageAreaItemPacks.filter(x => x.areaItems && x.areaItems.length !== 0)
      : [];
  }

  onAreaItemPackSelected(areaItemPack: AreaItemPack, selectedAreaItem: AreaItem = null): void {
    this.bookingStepService.update(
      BookingStepEnum.SelectBookingEventsPacks,
      areaItemPack,
      selectedAreaItem
    );
  }

  onShowGroupEventPage(): void {
    this.bookingStepService.update(
      BookingStepEnum.GroupEvent
    );
  }

  getInternalEventInfoLink(): string {
    return environment.internalEventInfoLink;
  }
}
